export default __webpack_public_path__ + "static/media/p-l.96e06e03.png";